import React from 'react';
 
import bannerBg from '../assets/img/Banners/about-us-banner-1.jpg';
import PageBanner from '../Components/PageBanner';
import Details from '../Components/Services/Details';
import BlogsDetailsData from '../Components/Blog/BlogsDetailsData';
import { useParams } from 'react-router-dom';

const ServiceDetails = () => {
  const { blogUrl } = useParams();
  console.log(blogUrl)
  const blog = BlogsDetailsData.find(b => b.href === blogUrl);

  return (
    <>
      <PageBanner title='Blogs Details' bannerBg={bannerBg} currentPage='Blogs Details' />
      {blog ? <Details blog={blog} /> : <h1 className='p-50'>Blog not found</h1>}
      
    </>
  );
};

export default ServiceDetails;
 